<div id="main-content" class="wrapper has-padding margin-height zoom-margin" (focusout)="onFocusOutMainContent($event)">
  @if (consentData ) {
    <form [formGroup]="consentGroup" (ngSubmit)="onSubmit()">
      <div class="max-width-1024">
        <h2 class="bofa--heading is-4">Certification</h2>
        <div [innerHTML]="consentInstruction"></div>
        <mat-checkbox formControlName="certificationCheck" (click)="onChangecertificationCheck()"
          class="minor-check-padding" aria-required="true" required (focusout)="consentOnBlur()"
          (focusin)="consentOnFocus()">
          <mat-label><abbr title="required">* </abbr><span class="white-space-normal"
        [innerHTML]="consentCheckInstruction"></span><span class="white-space-normal"> I further understand and
      agree to the information presented. </span>
    </mat-label>
  </mat-checkbox>
  @if (submit.value && certificationCheck.hasError('required') && check) {
    <mat-error class="white-space-normal">
      Please check the box to agree to the above language
    </mat-error>
  }
  <mat-form-field class="max-zoom margin-width">
    <mat-label>Certification date and time</mat-label>
    <input matInput value="{{ date }}" matInput disabled>
  </mat-form-field>
  @if (consentData) {
    <div class="margin-max">
      <app-wet-signature [signatureImg]="signatureImg" (sigURL)="getUrl($event)" (sigCheck)="sigCheck($event)">
      </app-wet-signature>
      @if (output.hasError('invalid') || sigCheckValue) {
        <mat-error> Please enter electronic signature </mat-error>
      }
    </div>
  }
  @if (showOusAttachments) {
    <div>
      <p id="required" class="global-red bofa--heading is-6 has-no-margin bottom-space">Required Documentation </p>
      <div class="bofa--alert has-background cool-gray-5 has-padding level-text">
        <span class="padding-10">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" class="img-size" aria-label="Alert icon">
            <g data-name="ICON OUTLINES">
              <path fill="#012169" d="M12,2A10,10,0,1,0,22,12,10.011,10.011,0,0,0,12,2Zm0,19a9,9,0,1,1,9-9A9.01,9.01,0,0,1,12,21Z" transform="translate(-2 -2)"/>
              <path fill="#012169" d="M11.992,6.848a.632.632,0,0,0-.617.64.625.625,0,0,0,1.25,0A.635.635,0,0,0,11.992,6.848Z" transform="translate(-2 -2)"/>
            <rect fill="#012169" x="9.5" y="7" width="1" height="8"/></g>
          </svg>
        </span>
        <span class="font-size-14">Completed documents must be uploaded on the Certification tab prior to
        submitting the form.</span>
      </div>
      @if (!consentChange) {
        <div>
          <!-- set focus when incomplete -->
          <div tabindex="-1" #addElement class="bofa--skiplink">
          </div>
          <table [class.border-red]="border" aria-labelledby="required" mat-table [dataSource]="ousDataSource">
            <ng-container matColumnDef="attachmentName">
              <td mat-cell *matCellDef="let element">
                @if (element.downloadble === 1) {
                  <span><a
                    href="/bsiAF/api/downloadOUSParentDocument?ousAttachmentID={{element.attachmentId}}&verifyId={{verifyId.value}}"
                    class="af-anchor" aria-label="download {{element.attachmentName}}"> {{element.attachmentName }}
                  </a></span>
                }
                <div class="name-link">
                  @if (element.downloadble !== 1) {
                    <span>{{element.attachmentName}}</span>
                  }
                  @if (element.attachmentId === 32) {
                    <span>
                      <a href="javascript:void(0)" target="_blank" rel="noopener noreferrer" (click)="loadDocumentHelp()"
                      aria-label="valid document help link">Valid document help link</a>
                    </span>
                  }
                </div>
              </td>
            </ng-container>
            <ng-container matColumnDef="downloadble">
              <td mat-cell *matCellDef="let element">
                <div>
                  <button type="button" class="bofa--button secondary outlined height-padding" color="primary"
                    [disabled]="element.attachmentCheck || formSubmitted "
                    (click)="openFileDialog(true ,element.attachmentId )" aria-label="attach required file">
                    <div class="button-content">
                      <span>
                        <svg class="width-height-margin" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" x="0px" y="0px" viewBox="0 0 24 24" aria-label="document">
                          <g>
                            <rect fill="none" width="24" height="24"/>
                            <path d="M4.3,1.5v21H15l4.7-4.7V1.5H4.3z M5.3,2.5h13.4v14.6h-4.4v4.4h-9V2.5z M18,18.1l-2.7,2.7v-2.7H18z"/>
                            <rect x="7.5" y="11.5" width="8.9" height="1"/>
                            <rect x="7.5" y="7.1" width="8.9" height="1"/>
                            <rect x="7.5" y="15.9" width="5.6" height="1"/>
                          </g>
                        </svg>
                      </span>
                      <span class="padding-10"> Attach file </span>
                    </div>
                  </button>
                </div>
              </td>
            </ng-container>
            <ng-container matColumnDef="attachmentId">
              <td mat-cell *matCellDef="let element">
                <mat-checkbox [disabled]="true" [checked]="element.attachmentCheck">
                  <mat-label class="bofa--skiplink">box</mat-label>
                </mat-checkbox>
              </td>
            </ng-container>
            <tr mat-row *matRowDef="let row; columns: displayedOusColumns;"></tr>
          </table>
        </div>
      }
      <!-- On Zoom -->
      @if (consentChange) {
        <div>
          <!-- set focus when incomplete -->
          <div tabindex="-1" #addElement class="bofa--skiplink">
          </div>
          <table [class.border-red]="border" aria-labelledby="required" #addElement class="mat-table-space" mat-table
            [dataSource]="ousDataSource">
            <ng-container matColumnDef="attachmentName">
              <td mat-cell *matCellDef="let element">
                @if (element.downloadble === 1) {
                  <span class="margin-top"><a
                    href="/bsiAF/api/downloadOUSParentDocument?ousAttachmentID={{element.attachmentId}}&verifyId={{verifyId.value}}"
                    class="af-anchor" aria-label="download {{element.attachmentName}}"> {{element.attachmentName }}
                  </a></span>
                }
                <div class="name-link">
                  @if (element.downloadble !== 1) {
                    <span>{{element.attachmentName}}</span>
                  }
                  @if (element.attachmentId === 32) {
                    <span>
                      <a href="javascript:void(0)" target="_blank" rel="noopener noreferrer" (click)="loadDocumentHelp()"
                      aria-label="valid document help link">Valid document help link</a>
                    </span>
                  }
                </div>
                <div class="zoom-attach">
                  <button type="button" class="bofa--button secondary outlined height-padding" color="primary"
                    [disabled]="element.attachmentCheck || formSubmitted "
                    (click)="openFileDialog(true ,element.attachmentId )" aria-label="attach required file">
                    <span>
                      <svg class="width-height-margin" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 24 24" aria-label="document">
                        <g>
                          <rect fill="none" width="24" height="24"/>
                          <path d="M4.3,1.5v21H15l4.7-4.7V1.5H4.3z M5.3,2.5h13.4v14.6h-4.4v4.4h-9V2.5z M18,18.1l-2.7,2.7v-2.7H18z"/>
                          <rect x="7.5" y="11.5" width="8.9" height="1"/>
                          <rect x="7.5" y="7.1" width="8.9" height="1"/>
                          <rect x="7.5" y="15.9" width="5.6" height="1"/>
                        </g>
                      </svg>
                    </span>
                    <span class="padding-10"> Attach file </span>
                  </button>
                </div>
              </td>
            </ng-container>
            <ng-container matColumnDef="downloadble">
              <td mat-cell *matCellDef="let element">
              </td>
            </ng-container>
            <ng-container matColumnDef="attachmentId">
              <td mat-cell *matCellDef="let element">
                <mat-checkbox [disabled]="true" [checked]="element.attachmentCheck">
                </mat-checkbox>
              </td>
            </ng-container>
            <tr mat-row *matRowDef="let row; columns: displayedOusColumns;"></tr>
          </table>
        </div>
      }
    </div>
  }
  @if (isMinor) {
    <div class="padding-top-8">
      <mat-card appearance="outlined" class="af-mat-card mat-elevation-z">
        <mat-card-header>
          <mat-card-title class="text-max"><abbr title="required">* </abbr>Based on your date of birth, you must
          attach an Under 18
        Consent Form before submitting your application:</mat-card-title>
      </mat-card-header>
      <mat-card-content>
        <div class="line-height-18">
          <ol type="1">
            <li>Download and print the <u><a target="_blank" rel="noopener noreferrer" class="af-anchor"
              href='assets/Under_18_Consent_Form.pdf' aria-label="under 18 consent form">Under 18 Consent
            Form</a></u>.</li>
            <li>
              Have your parent/guardian complete the form and <strong>get it notarized.</strong>
            </li>
            <li>
              Log back into this site, attach the completed form and submit your application.
            </li>
            <li>
              Your Staffing representative will receive and validate your form is completed correctly.
            </li>
          </ol>
          <strong>Note:</strong> If not correct, the system will reject the attachment and you will receive an email
          instructing you to attach a completed form.
        </div>
      </mat-card-content>
    </mat-card>
  </div>
}
<h3 class="global-red bofa--heading is-5 ">Other attachments</h3>
<div class="flex-container">
  <mat-card appearance="outlined" class="af-mat-card mat-elevation-z fx-flex-50">
    <mat-card-header>
      <div mat-card-avatar class="example-header-image">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" class="img-size" aria-label="attachments icon">
          <g data-name="ICON OUTLINES">
            <path fill="#012169" d="M12,2A10,10,0,1,0,22,12,10.011,10.011,0,0,0,12,2Zm0,19a9,9,0,1,1,9-9A9.01,9.01,0,0,1,12,21Z" transform="translate(-2 -2)"/>
            <path fill="#012169" d="M11.992,6.848a.632.632,0,0,0-.617.64.625.625,0,0,0,1.25,0A.635.635,0,0,0,11.992,6.848Z" transform="translate(-2 -2)"/>
          <rect fill="#012169" x="9.5" y="7" width="1" height="8"/></g>
        </svg>
      </div>
      <h4 class="mat-mdc-card-title">Other Attachments are optional</h4>
    </mat-card-header>
    <mat-card-content>
      <p>If you had any gaps within your employment history in the last 5 years, please upload
        documentation for explanation of this gap. You may also attach any additional documents
      evidencing your education, previous employment or professional qualifications.</p>
    </mat-card-content>
  </mat-card>
  <mat-card appearance="outlined" class="af-mat-card mat-elevation-z fx-flex-45">
    <mat-card-header>
      <div mat-card-avatar class="example-header-image">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" class="img-size"  aria-label="alert icon">
          <g data-name="ICON OUTLINES">
            <path fill="#012169" d="M12,2A10,10,0,1,0,22,12,10.011,10.011,0,0,0,12,2Zm0,19a9,9,0,1,1,9-9A9.01,9.01,0,0,1,12,21Z" transform="translate(-2 -2)"/>
            <path fill="#012169" d="M11.992,6.848a.632.632,0,0,0-.617.64.625.625,0,0,0,1.25,0A.635.635,0,0,0,11.992,6.848Z" transform="translate(-2 -2)"/>
          <rect fill="#012169" x="9.5" y="7" width="1" height="8"/></g>
        </svg>
      </div>
      <h4 class="mat-mdc-card-title">Allowed file formats</h4>
    </mat-card-header>
    <mat-card-content>
      <p class="bofa--heading is-9">ZIP, PDF, DOC, DOCX, EML, MSG, TIFF, JPEG, GIF, XLS, XLSX, PNG, JPG, PPT and
        PPTX
      </p>
    </mat-card-content>
  </mat-card>
</div>
<div class="is-stacked">
  <button type="button" class="bofa--button secondary outlined height-padding" color="primary"
    [disabled]="formSubmitted" (click)="openFileDialog(false)" aria-label="attach optional file">
    <span>
      <svg class="width-height-margin" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 24 24" aria-label="document">
        <g>
          <rect fill="none" width="24" height="24"/>
          <path d="M4.3,1.5v21H15l4.7-4.7V1.5H4.3z M5.3,2.5h13.4v14.6h-4.4v4.4h-9V2.5z M18,18.1l-2.7,2.7v-2.7H18z"/>
          <rect x="7.5" y="11.5" width="8.9" height="1"/>
          <rect x="7.5" y="7.1" width="8.9" height="1"/>
          <rect x="7.5" y="15.9" width="5.6" height="1"/>
        </g>
      </svg>
    </span>
    <span class="padding-10"> Attach file</span>
  </button>
</div>
<div class="table-container bottom-space">
  <span class="hide" id="attachTable">Attached files</span>
  <table mat-table aria-labelledby="attachTable" [dataSource]="dataSource">
    <ng-container matColumnDef="fileName">
      <th scope="col" class="cell-width" mat-header-cell *matHeaderCellDef>File Name</th>
      <td mat-cell *matCellDef="let element">
        <button type="button" class="bofa--button secondary outlined" title="Download Attachment {{element.fileName}}"
          aria-label="download {{element.fileName}}"
          (click)="downloadAttachment(element.mongoAttachmentId, element.fileName)">{{element.fileName}}
        </button>
      </td>
    </ng-container>
    <ng-container matColumnDef="descOfFileName">
      <th scope="col" class="cell-width" mat-header-cell *matHeaderCellDef>Description</th>
      <td mat-cell *matCellDef="let element"> {{element.descOfFileName}} </td>
    </ng-container>
    <ng-container matColumnDef="fileType">
      <th scope="col" mat-header-cell *matHeaderCellDef>Type</th>
      <td mat-cell *matCellDef="let element"> {{element.fileType}} </td>
    </ng-container>
    <ng-container matColumnDef="fileSize">
      <th scope="col" class="cell-width" mat-header-cell *matHeaderCellDef>Size (In Bytes)</th>
      <td mat-cell *matCellDef="let element"> {{element.fileSize}} </td>
    </ng-container>
    <ng-container matColumnDef="attachedBy">
      <th scope="col" class="cell-width" mat-header-cell *matHeaderCellDef>Attached by</th>
      <td mat-cell *matCellDef="let element"> {{element.attachedBy}} </td>
    </ng-container>
    <ng-container matColumnDef="attachedDateString">
      <th scope="col" class="cell-width" mat-header-cell *matHeaderCellDef>Date attached</th>
      <td mat-cell *matCellDef="let element"> {{element.attachedDateString}} </td>
    </ng-container>
    <ng-container matColumnDef="remove">
      <th scope="col" class="text-center" mat-header-cell *matHeaderCellDef>Action</th>
      <td class="text-center" mat-cell *matCellDef="let element">
        @if (!formSubmitted) {
          <button
            type="button"
            class="af-anchor"
            (click)="removeAttachment(element.mongoAttachmentId,element.typeOfAttachmentId)"
            aria-label="Remove {{ element.fileName }}">
            Remove <span class="hide">&nbsp;{{ element.fileName }}</span>
          </button>
        }
      </td>
    </ng-container>
    <tr mat-header-row *matHeaderRowDef="displayedColumns ; "></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
  </table>
  <mat-paginator aria-label="Attached files pagination" [pageSizeOptions]="[ 10, 20 ]"
  showFirstLastButtons></mat-paginator>
</div>
<div class="bottom-space">
  <mat-checkbox formControlName="consentLegalRequirementsMet" aria-required="true" required
    (focusout)="legalOnBlur()" (focusin)="legalOnFocus()" class="minor-check-padding">
    <mat-label class="white-space-normal"><abbr title="required">* </abbr> Yes, I certify that I have read and
    understand the information
    presented.
  </mat-label>
</mat-checkbox>
@if (submit.value && consentLegalRequirementsMet.hasError('required') && checkTwo) {
  <mat-error class="white-space-normal"
    >
    Please check the box to agree to the above language.
  </mat-error>
}
</div>
<div>
  <mat-form-field class="max-zoom width-margin-top-bottom" hideRequiredMarker>
    <mat-label><abbr title="required">* </abbr>Please enter your full name</mat-label>
    <input matInput placeholder="Full name" formControlName="consentApplicantSignedName" required maxlength="250">
    <mat-error>Please enter your full name</mat-error>
  </mat-form-field>
</div>
<mat-form-field class="max-zoom" class="width-350">
  <mat-label>Date signed</mat-label>
  <input matInput value="{{ legalRequirementCheckDate }}" matInput disabled>
</mat-form-field>
</div>
</form>
} @else {
  Loading consent data...
}
</div>

